import { Disclosure, Menu, Transition } from '@headlessui/react';
import Muffin from '../assets/primary_logo.png';

export default function UnauthenticatedHeader() {
  return (
    <>
      <div>
        <Disclosure as="nav" className="border-b border-gray-200 bg-white">
          {({ open }) => (
            <>
              <div className="mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex h-16 justify-between">
                  <div className="flex">
                    <div className="flex flex-shrink-0 items-center">
                      <img
                        className="block h-8 w-auto lg:hidden"
                        src={Muffin}
                        alt="Muffin Data"
                      />
                      <img
                        className="hidden h-8 w-auto lg:block"
                        src={Muffin}
                        alt="Muffin Data"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
        </Disclosure>
      </div>
    </>
  );
}
